<template>
  <div class="animated fadeIn">
    <div class="card">
      <div class="card-header">
        <span v-if="mData.viewMode == 'create'">{{aLang.c_create}} {{aLang.da_title}}</span>
        <span v-if="mData.viewMode == 'update'">{{aLang.c_update}} {{aLang.da_title}}</span>
        <span v-if="mData.viewMode == 'detail'">{{aLang.c_detail}} {{aLang.da_title}}</span>
        <div class="card-header-actions"></div>
      </div>
      <div class="card-body">
        <el-form
          :model="mData.dataForm"
          :rules="mData.validForm"
          ref="myForm"
          label-width="100%"
          label-position="top"
        >
          <b-row>
            <b-col md="6">
              <el-form-item :label="aLang.da_object" prop="doi_tuong">
                <el-select
                  v-model="mData.dataForm.doi_tuong"
                  :placeholder="aLang.c_select"
                  clearable
                  filterable
                  :disabled="mData.viewMode != 'create'"
                >
                  <el-option
                    v-for="item in mData.dataDefault.doiTuongNhan"
                    :key="item.code"
                    :label="item.text"
                    :value="item.code"
                  ></el-option>
                </el-select>
              </el-form-item>
            </b-col>
            <b-col md="3">
              <el-form-item :label="aLang.da_order" prop="thu_tu">
                <el-input
                  type="number"
                  v-model="mData.dataForm.thu_tu"
                  :disabled="mData.viewMode == 'detail'"
                  :min="1"
                  clearable
                ></el-input>
              </el-form-item>
            </b-col>
            <b-col md="3">
              <el-form-item label=" " prop="co_hieu_luc">
                <el-checkbox
                  v-model="mData.dataForm.co_hieu_luc"
                  :disabled="mData.viewMode == 'detail'"
                  
                >{{aLang.da_effect}}</el-checkbox>
              </el-form-item>
            </b-col>
            <!-- <b-col md="3">
              <el-form-item label="Trạng thái" prop="co_hieu_luc">
                <el-select
                  v-model="mData.dataForm.co_hieu_luc"
                  :placeholder="aLang.c_select"
                  :disabled="mData.viewMode == 'detail'"
                  clearable
                  filterable
                >
                  <el-option
                    v-for="item in mData.dataDefault.trangThai"
                    :key="item.code"
                    :label="item.text"
                    :value="item.code"
                  ></el-option>
                </el-select>
              </el-form-item>
            </b-col> -->
          </b-row>
          <b-row>
            <b-col md="6">
              <el-form-item
                :label="aLang.da_effective_date"
                prop="tu_ngay"
                :error="fn_compareTime()"
                
              >
                <el-date-picker
                  type="datetime"
                  :format="aElement.datepicker.formatDatetime"
                  :valueFormat="aElement.datepicker.valueFormat"
                  v-model="mData.dataForm.tu_ngay"
                  :placeholder="aElement.datepicker.placeholderDatetime"
                  clearable
                  :disabled="mData.viewMode == 'detail'"
                ></el-date-picker>
              </el-form-item>
            </b-col>
            <b-col md="6">
              <el-form-item
                :label="aLang.da_expiration_date"
                prop="den_ngay"
                :error="fn_compareTime()"
                
              >
                <el-date-picker
                  type="datetime"
                  :format="aElement.datepicker.formatDatetime"
                  :valueFormat="aElement.datepicker.valueFormat"
                  v-model="mData.dataForm.den_ngay"
                  :placeholder="aElement.datepicker.placeholderDatetime"
                  clearable
                  :disabled="mData.viewMode == 'detail'"
                ></el-date-picker>
              </el-form-item>
            </b-col>
          </b-row>

         <b-row>
            <b-col md="12">
              <el-form-item :label="aLang.da_content + aLang.da_vietnam" prop="noi_dung.vi">
                <editor-component
                  :prop-data-editor="mData.dataForm.noi_dung"
                  :prop-data-editor-key="'vi'"
                  :prop-data-editor-disabled="mData.viewMode == 'detail'"
                ></editor-component>
              </el-form-item>
            </b-col>
            <b-col md="4">
              <el-form-item class="mb-2" label="File đính kèm (Tiếng Việt)">
                <el-upload
                  action
                  :auto-upload="false"
                  list-type="text"
                  :limit="mData.fileUploadOption.FileDinhKemTiengViet.limit"
                  :accept="mData.fileUploadOption.FileDinhKemTiengViet.accept"
                  :on-change="fn_uploadChangeFileDinhKemTiengViet"
                  :on-preview="fn_uploadPreviewFileDinhKemTiengViet"
                  :on-remove="fn_uploadRemoveFileDinhKemTiengViet"
                  :on-exceed="fn_uploadExceedFileDinhKemTiengViet"
                  multiple
                  :file-list="mData.fileUploadOption.FileDinhKemTiengViet.fileList"
                  :disabled="mData.viewMode == 'detail'"
                >
                  <el-button
                    size="small"
                    type="primary"
                    plain
                    :disabled="mData.viewMode == 'detail'"
                    v-if="mData.viewMode != 'detail'"
                  >Chọn tệp</el-button>
                  <el-button
                    size="small"
                    type="info"
                    plain
                    :disabled="mData.viewMode == 'detail'"
                    v-if="mData.viewMode == 'detail'"
                  >Chọn tệp</el-button>
                </el-upload>
                <el-dialog
                  :close-on-click-modal="true"
                  :visible.sync="mData.fileUploadOption.FileDinhKemTiengViet.dialogVisible"
                  width="60%"
                  top="51px"
                  title="Chi tiết"
                >
                  <img
                    width="100%"
                    :src="mData.fileUploadOption.FileDinhKemTiengViet.dialogImageUrl"
                    alt
                  />
                </el-dialog>
              </el-form-item>
            </b-col>
          </b-row>

          <b-row>
            <b-col md="12">
              <el-form-item :label="aLang.da_content + aLang.da_english" prop="noi_dung.en">
                <editor-component
                  :prop-data-editor="mData.dataForm.noi_dung"
                  :prop-data-editor-key="'en'"
                  :prop-data-editor-disabled="mData.viewMode == 'detail'"
                ></editor-component>
              </el-form-item>
            </b-col>
            <b-col md="4">
              <el-form-item class="mb-1" label="File đính kèm (Tiếng Anh)">
                <el-upload
                  action
                  :auto-upload="false"
                  list-type="text"
                  :limit="mData.fileUploadOption.FileDinhKemTiengAnh.limit"
                  :accept="mData.fileUploadOption.FileDinhKemTiengAnh.accept"
                  :on-change="fn_uploadChangeFileDinhKemTiengAnh"
                  :on-preview="fn_uploadPreviewFileDinhKemTiengAnh"
                  :on-remove="fn_uploadRemoveFileDinhKemTiengAnh"
                  :on-exceed="fn_uploadExceedFileDinhKemTiengAnh"
                  multiple
                  :file-list="mData.fileUploadOption.FileDinhKemTiengAnh.fileList"
                  :disabled="mData.viewMode == 'detail'"
                >
                  <el-button
                    size="small"
                    type="primary"
                    plain
                    :disabled="mData.viewMode == 'detail'"
                    v-if="mData.viewMode != 'detail'"
                  >Chọn tệp</el-button>
                  <el-button
                    size="small"
                    type="info"
                    plain
                    :disabled="mData.viewMode == 'detail'"
                    v-if="mData.viewMode == 'detail'"
                  >Chọn tệp</el-button>
                </el-upload>
                <el-dialog
                  :close-on-click-modal="true"
                  :visible.sync="mData.fileUploadOption.FileDinhKemTiengAnh.dialogVisible"
                  width="60%"
                  top="51px"
                  title="Chi tiết"
                >
                  <img
                    width="100%"
                    :src="mData.fileUploadOption.FileDinhKemTiengAnh.dialogImageUrl"
                    alt
                  />
                </el-dialog>
              </el-form-item>
            </b-col>
          </b-row>

          <el-form-item class="text-center mt-3">
            <el-button
              type="info"
              plain
              @click="fn_submitForm('create')"
              v-ladda
              v-if="mData.viewMode == 'create'"
            >{{aLang.c_create}}</el-button>

            <el-button
              type="info"
              plain
              @click="fn_submitForm('update')"
              v-ladda
              v-if="mData.viewMode == 'update'"
            >{{aLang.c_update}}</el-button>

            <el-button @click="fn_go()" type="info" plain>{{aLang.c_back}}</el-button>
          </el-form-item>
        </el-form>
      </div>
    </div>
  </div>
</template>

<script>
import LanguageService from "../../../service/LanguageService";
import DataService from "../../../service/DataService";
import MethodService from "../../../service/MethodService";
import ExtensionService from "../../../service/ExtensionService";
import CanhBaoHangNgayModel from "./CanhBaoHangNgayModel";
import CanhBaoHangNgayApi from "../../../moduleApi/CanhBaoHangNgayApi";
import FileApi from '@/moduleApi/FileApi';
import EditorComponent from "../../../component/EditorComponent";

export default {
  components: {  
    EditorComponent
  },
  data() {
    return {
      aLang: LanguageService.lang,
      aElement: MethodService.element,
      mData: {
        viewMode: "create",
        moduleName: "CanhBaoHangNgay",
        dataDefault: {
          roles: DataService.rolesInForm,
          // trangThai: CanhBaoHangNgayModel.trangThai,
          doiTuongNhan: DataService.loaiNhomPhanHoi,
          validErrorTime: false,
        },
        dataForm: MethodService.copyObject(CanhBaoHangNgayModel.dataForm),
        validForm: CanhBaoHangNgayModel.validForm,
        dialog: {},
        fileUploadOption: MethodService.copyObject(
          CanhBaoHangNgayModel.dataFormOther.fileUploadOption
        )
      }
    };
  },
  methods: {
    fn_submitForm(type) {
      this.$refs["myForm"].validate(async valid => {        
        if (valid && !this.mData.dataDefault.validErrorTime) {
          let data = MethodService.copyObject(this.mData.dataForm);
          if (data.noi_dung.vi) {
            //replace http để lấy id ảnh
            data.noi_dung.vi = MethodService.replaceURLImage(data.noi_dung.vi);
          }
          if (data.noi_dung.en) {
            //replace http để lấy id ảnh
            data.noi_dung.en = MethodService.replaceURLImage(data.noi_dung.en);
          }
          
          if (type == "create") {
            // debugger;
            await CanhBaoHangNgayApi.create(data);
            this.fn_go();
          }
          if (type == "update") {
            data.id = this.$router.currentRoute.params.id;
            
            await CanhBaoHangNgayApi.update(data);
            this.fn_go(-1);
          }
        } else {
          // console.log(this.mData.dataDefault.validErrorTime);
          MethodService.stopLadda();
          return false;
        }
      });
    },
    fn_resetForm() {
      this.mData.dataForm = MethodService.copyObject(
        CanhBaoHangNgayModel.dataForm
      );
      this.mData.dataForm.noi_dung.vi = "";
      this.mData.dataForm.noi_dung.en = "";
      this.mData.fileUploadOption = MethodService.copyObject(
        CanhBaoHangNgayModel.dataFormOther.fileUploadOption
      );
      this.$refs["myForm"].resetFields();
    },
    fn_go() {
      this.$router.go(-1);
    },
    async fn_getDataById(id) {
      let res = await CanhBaoHangNgayApi.findById(id);
      
      if (res.result.noi_dung.vi) {
        res.result.noi_dung.vi = MethodService.unreplaceURLImage(
          res.result.noi_dung.vi
        );
      }
      if (res.result.noi_dung.en) {
        res.result.noi_dung.en = MethodService.unreplaceURLImage(
          res.result.noi_dung.en
        );
      }
      if(res.result.file_dinh_kem_ids == undefined){
        res.result.file_dinh_kem_ids = {
          vi: [],
          en: []
        };
      }
      if(res.result.file_dinh_kem_ids.vi){
        let listFileVi = await FileApi.list({
          limit: res.result.file_dinh_kem_ids.vi.length,
          filters: "id:in:" + res.result.file_dinh_kem_ids.vi.join(",")
        });
        let dataVi = [];
        if (listFileVi && listFileVi.result) {
          dataVi = listFileVi.result;
          dataVi.map(item => {
            item.url = ExtensionService.urlImg + item.id;
          });
        }
        this.mData.fileUploadOption.FileDinhKemTiengViet.fileList = dataVi;
      }
      if(res.result.file_dinh_kem_ids.en){
        let listFileEn = await FileApi.list({
          limit: res.result.file_dinh_kem_ids.en.length,
          filters: "id:in:" + res.result.file_dinh_kem_ids.en.join(",")
        });
        let dataEn = [];
        if (listFileEn && listFileEn.result) {
          dataEn = listFileEn.result;
          dataEn.map(item => {
            item.url = ExtensionService.urlImg + item.id;
          });
        }
        this.mData.fileUploadOption.FileDinhKemTiengAnh.fileList = dataEn;
      }
      this.mData.dataForm = res.result;
    },

    async fn_initDataDefault() {
    },

    fn_uploadRemoveFileDinhKemTiengViet(file, fileList) {
      let data = [];
      $.each(fileList, (i, el) => {
        data.push(el.id);
      });
      this.mData.dataForm.file_dinh_kem_ids.vi = data;
    },
    fn_uploadRemoveFileDinhKemTiengAnh(file, fileList) {
      let data = [];
      $.each(fileList, (i, el) => {
        data.push(el.id);
      });
      this.mData.dataForm.file_dinh_kem_ids.en = data;
    },
    fn_uploadChangeFileDinhKemTiengViet(file, fileList) {
      // debugger
      ExtensionService.upload(file, "canhBaoHangNgay")
        .then(res => {
          if (
            this.mData.dataForm.file_dinh_kem_ids &&
            this.mData.dataForm.file_dinh_kem_ids.vi
          ) {
            this.mData.dataForm.file_dinh_kem_ids.vi.push(res.result);
          } else {
            this.mData.dataForm.file_dinh_kem_ids.vi= [];
            this.mData.dataForm.file_dinh_kem_ids.vi.push(res.result);
          }

          $.each(fileList, (i, el) => {
            if (el.uid == file.uid) {
              el.id = res.result;
            }
          });
          // debugger
          this.mData.fileUploadOption.FileDinhKemTiengViet.fileList = fileList;
        })
        .catch(error => {
          $.each(fileList, (i, el) => {
            if (el.uid == file.uid) {
              fileList.splice(i, 1);
            }
          });
        });
    },
    fn_uploadChangeFileDinhKemTiengAnh(file, fileList) {
      // debugger
      ExtensionService.upload(file, "canhBaoHangNgay")
        .then(res => {
          // debugger
          if (
            this.mData.dataForm.file_dinh_kem_ids &&
            this.mData.dataForm.file_dinh_kem_ids.en
          ) {
            this.mData.dataForm.file_dinh_kem_ids.en.push(res.result);
          } else {
            this.mData.dataForm.file_dinh_kem_ids.en= [];
            this.mData.dataForm.file_dinh_kem_ids.en.push(res.result);
          }

          $.each(fileList, (i, el) => {
            if (el.uid == file.uid) {
              el.id = res.result;
            }
          });
          // debugger
          this.mData.fileUploadOption.FileDinhKemTiengAnh.fileList = fileList;
        })
        .catch(error => {
          $.each(fileList, (i, el) => {
            if (el.uid == file.uid) {
              fileList.splice(i, 1);
            }
          });
        });
    },
    fn_uploadExceedFileDinhKemTiengViet(files, fileList) {
      toastr.info(
        `Chỉ tải lên tối đa ${this.mData.fileUploadOption.FileDinhKemTiengViet.limit} file`
      );
    },
    fn_uploadExceedFileDinhKemTiengAnh(files, fileList) {
      toastr.info(
        `Chỉ tải lên tối đa ${this.mData.fileUploadOption.FileDinhKemTiengAnh.limit} file`
      );
    },
    fn_uploadPreviewFileDinhKemTiengViet(file) {
      this.mData.fileUploadOption.FileDinhKemTiengViet.dialogImageUrl = file.url;
      this.mData.fileUploadOption.FileDinhKemTiengViet.dialogVisible = true;

      // window.open(ExtensionService.urlFile + file.id);
    },
    fn_uploadPreviewFileDinhKemTiengAnh(file) {
      this.mData.fileUploadOption.FileDinhKemTiengAnh.dialogImageUrl = file.url;
      this.mData.fileUploadOption.FileDinhKemTiengAnh.dialogVisible = true;

      // window.open(ExtensionService.urlFile + file.id);
    },

    fn_compareTime() {    
      let timeStart = this.mData.dataForm.tu_ngay;
      let timeEnd = this.mData.dataForm.den_ngay;
      this.mData.dataDefault.validErrorTime = false;
      if (timeStart && timeEnd) {
        let time1 = "";
        let time2 = "";

        if (typeof timeStart == "string") {
          time1 = new Date(timeStart);
        }
        if (typeof timeEnd == "string") {
          time2 = new Date(timeEnd);
        }

        if (time1.getTime() >= time2.getTime()) {
          this.mData.dataDefault.validErrorTime = true;
          return LanguageService.lang.valid_compareTime;
        } else {
          return "";
        }
      } else {
        if (timeStart == null || timeEnd == null) {
          this.mData.dataDefault.validErrorTime = false;
        }
        // return LanguageService.lang.valid_required;
      }
    },

    fn_formatterDate(row, column, cellValue, index) {
      return MethodService.formatDate(cellValue, "date");
    },

    fn_formatterDatetime(row, column, cellValue, index) {
      return MethodService.formatDate(cellValue, "datetime");
    },

    //upload ảnh
    fn_uploadCheckFileSize(file) {
      return MethodService.checkFileSize(file, 3);
    },

    fn_uploadRemoveAnhDaiDien(file, fileList) {
      this.mData.dataForm.anh.anh_dai_dien = null;
      this.mData.fileUploadOption.AnhDaiDien.fileList = [];
    },
    fn_uploadChangeAnhDaiDien(file, fileList) {
      ExtensionService.upload(file, "CanhBaoHangNgay")
        .then(res => {
          this.mData.dataForm.anh.anh_dai_dien = res.result;
          this.mData.fileUploadOption.AnhDaiDien.fileList = fileList;
        })
        .catch(error => {
          $.each(fileList, (i, el) => {
            if (el.uid == file.uid) {
              fileList.splice(i, 1);
            }
          });
        });
    },
    fn_uploadExceedAnhDaiDien(files, fileList) {
      toastr.info(
        `Chỉ tải lên tối đa ${this.mData.fileUploadOption.AnhDaiDien.limit} file`
      );
    },
    fn_uploadPreviewAnhDaiDien(file) {
      this.mData.fileUploadOption.AnhDaiDien.dialogImageUrl = file.url;
      this.mData.fileUploadOption.AnhDaiDien.dialogVisible = true;
    },

    fn_uploadRemoveAnhCanhBaoHangNgay(file, fileList) {
      let data = [];
      $.each(fileList, (i, el) => {
        data.push(el.id);
      });
      this.mData.dataForm.anh.anh_tin_tuc = data;
    },
    fn_uploadChangeAnhCanhBaoHangNgay(file, fileList) {
      ExtensionService.upload(file, "CanhBaoHangNgay")
        .then(res => {
          this.mData.dataForm.anh.anh_tin_tuc.push(res.result);
          $.each(fileList, (i, el) => {
            if (el.uid == file.uid) {
              el.id = res.result;
            }
          });
          this.mData.fileUploadOption.AnhCanhBaoHangNgay.fileList = fileList;
        })
        .catch(error => {
          $.each(fileList, (i, el) => {
            if (el.uid == file.uid) {
              fileList.splice(i, 1);
            }
          });
        });
    },
    fn_uploadExceedAnhCanhBaoHangNgay(files, fileList) {
      toastr.info(
        `Chỉ tải lên tối đa ${this.mData.fileUploadOption.AnhCanhBaoHangNgay.limit} file`
      );
    },
    fn_uploadPreviewAnhCanhBaoHangNgay(file) {
      this.mData.fileUploadOption.AnhCanhBaoHangNgay.dialogImageUrl = file.url;
      this.mData.fileUploadOption.AnhCanhBaoHangNgay.dialogVisible = true;
    },
    fn_addLatLng(lat, lng) {
      this.mData.dataForm.dia_diem.lat = lat;
      this.mData.dataForm.dia_diem.lng = lng;
    }
  },
  created: function() {
    this.fn_initDataDefault();

    if (
      this.$router.currentRoute.name ==
      "Admin-" + this.mData.moduleName + "-update"
    ) {
      this.mData.viewMode = "update";
    }
    if (
      this.$router.currentRoute.name ==
      "Admin-" + this.mData.moduleName + "-detail"
    ) {
      this.mData.viewMode = "detail";
    }
    if (this.$router.currentRoute.params.id) {
      this.fn_getDataById(this.$router.currentRoute.params.id);
    }
  },
  mounted: function() {}
};
</script>
<style scoped>
</style>